<template>
  <div
    :class="['dropdown', { open: dropdownOpen }]"
    v-click-outside="closeDropdown"
  >
    <div class="dropdown-button" @click="toggleDropdown">
      {{ current }}
      <img
        :src="
          `${baseUrl}assets/images/atoms-icons-actions-navigation-chevron-down.svg`
        "
        alt="arrow"
      />
    </div>
    <ul :style="{ height: dropdownOpen ? itemAmount * itemHeight + 'px' : 0 }">
      <slot></slot>
    </ul>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";
export default {
  props: ["current", "itemAmount"],
  data() {
    return {
      dropdownOpen: false,
      itemHeight: 53,
      baseUrl: process.env.BASE_URL
    };
  },
  methods: {
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    closeDropdown() {
      this.dropdownOpen = false;
    }
  },
  directives: {
    ClickOutside
  }
};
</script>

<style lang="scss" scoped>
.dropdown {
  position: relative;
  width: 100%;
  .dropdown-button {
    width: 100%;
    padding: 10px;
    background-color: #fff;
    border-radius: 5px;
    border: 1px solid #dce4e6;
    font-family: Avenir;
    font-size: 16px;
    font-weight: 500;
    font-style: italic;
    cursor: pointer;
    position: relative;
    img {
      position: absolute;
      right: 10px;
      top: 15px;
      width: 15px;
      transition: transform 0.2s ease;
    }
  }
  ul {
    width: 100%;
    position: absolute;
    top: 39px;
    left: 0;
    background: #fff;
    overflow-y: auto;
    max-height: 120px;
    z-index: 1;
    list-style-type: none;
    margin: 0;
    padding: 0;
    border: none;
    border-radius: 0 0 5px 5px;
    transition: height 0.3s ease;
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-thumb {
      background: $primary;
      border-radius: 3px;
      height: 20%;
    }
    li {
      opacity: 0;
      padding: 10px;
      border-bottom: 1px solid #dce4e6;
      &:hover {
        background: $primary;
        a {
          color: #fff !important;
          text-decoration: none !important;
        }
      }

      a {
        display: inline-block;
        width: 100%;
        height: 100%;
        font-family: Avenir;
        font-size: 16px;
        font-weight: 500;
        color: #000;
      }
    }
  }
  &.open {
    .dropdown-button {
      border-radius: 5px 5px 0 0;
      img {
        transform: rotate(180deg);
      }
    }
    ul {
      border: 1px solid #dce4e6;
      border-top: none;
      padding-top: 0;
      li {
        opacity: 1;
      }
    }
  }
}
</style>
